var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vCenterWrapper bg-primary",attrs:{"id":"footerWrapper"}},[_vm._v("2021 - New Spirit "),_c('div',{attrs:{"id":"snackbar"}})])}]

export { render, staticRenderFns }